if (!customElements.get('custom-accordion')) {
  class CustomAccordion extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        accordionRow: '.accordion_item',
        accordionTrigger: '.accordion-heading',
        accordionContentWrapper: '.accordion-more',
        accordionContent: '.accordion-more .accordion-content',
      };

      this.onlyTrigger = this.dataset.onlyTrigger == 'true';
      this.hasNested = this.dataset.hasNested == 'true';
      this.closeOnOutsideClick = this.dataset.closeOnOutsideClick == 'true';

      this.accordionRows = this.querySelectorAll(this.selectors.accordionRow);
      this.accordionTrigger = this.querySelectorAll(
        this.onlyTrigger ? this.selectors.accordionTrigger : this.selectors.accordionRow,
      );
    }

    toggleAccordion(event) {
      event.stopPropagation();

      const isNavLinkOrModalBtn = event.target.matches('a[href]') || event.target.closest('a[href]') || event.target.id == 'FittingModalBtn';
      if (isNavLinkOrModalBtn) {
        return; // Don't toggle accordion when clicking navigation links
      }

      const target_row = event.target.closest(this.selectors.accordionRow);
      const heading = event.target.closest(this.selectors.accordionTrigger);

      if (target_row && heading && heading.closest(this.selectors.accordionRow) === target_row) {
        if (target_row.classList.contains('active')) {
          this.close(target_row);
        } else {
          this.open(target_row);
        }
      }
    }

    open(row) {
      if (this.dataset.allowMultipleOpen == 'false')
        this.accordionRows.forEach((accordionRow) => this.close(accordionRow));
      row.classList.add('active');
      const verticalPadding = window.innerWidth <= 989 ? 30 : 30;
      const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);
      const row_content = row.querySelector(this.selectors.accordionContent);
      row_wrapper.style.setProperty('max-height', row_content.offsetHeight + verticalPadding + 'px');
      row_wrapper.style.setProperty('opacity', 1);

      if (this.hasNested) {
        const outer_row_wrapper = row.closest(this.selectors.accordionContentWrapper);
        if (!outer_row_wrapper) return;
        const outer_row_content = outer_row_wrapper.querySelector(this.selectors.accordionContent);
        outer_row_wrapper.style.setProperty(
          'max-height',
          outer_row_content.offsetHeight + row_content.offsetHeight + 'px',
        );
        outer_row_wrapper.style.setProperty('opacity', 1);
      }
    }

    close(row) {
      row.classList.remove('active');
      const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);

      row_wrapper.style.setProperty('max-height', '0px');
      row_wrapper.style.setProperty('opacity', 0);
    }

    connectedCallback() {
      if (this.dataset.mobileOnly == 'true') {
        this.accordionTrigger.forEach((trigger, index) => {
          trigger.addEventListener('click', this.toggleAccordion.bind(this));
          if (trigger.dataset.initialOpenedIndex && trigger.dataset.initialOpenedIndex == index) {
            trigger.click();
          }
        });
      } else if (this.dataset.mobileOnly == 'false') {
        this.accordionTrigger.forEach((trigger, index) => {
          trigger.addEventListener('click', this.toggleAccordion.bind(this));
          if (trigger.dataset.initialOpenedIndex && trigger.dataset.initialOpenedIndex == index) {
            trigger.click();
          }
        });
      }
      this.accordionRows.forEach((row) => {
        if (row.getAttribute('data-default-closed') === 'true' && row.classList.contains('active') == false) {
          this.close(row);
        } else if (row.classList.contains('active')) {
          this.open(row);
        }
      });
      if (this.closeOnOutsideClick) {
        window.addEventListener('click', () => {
          this.accordionRows.forEach((row) => {
            if (row.classList.contains('active')) {
              this.close(row);
            }
          });
        });
      }
    }

    executeDefaultAccordionOpenState() {
      const accordionRows = this.querySelectorAll(this.selectors.accordionRow);
      accordionRows.forEach((row) => {
        if (row.getAttribute('data-default-closed') === 'true' && row.classList.contains('active') == false) {
          this.close(row);
        }
      });
    }

    disconnectedCallback() {
      this.accordionTrigger.forEach((trigger) => {
        trigger.removeEventListener('click', this.toggleAccordion);
      });
    }
  }

  window.customElements.define('custom-accordion', CustomAccordion);
}
